import React from 'react';

import { FormattedMessage } from 'react-intl';

import { InlineMessage, INLINE_MESSAGE_TYPES } from 'ui-components/components/inline-message';
import { Input, version2 } from 'ui-components/components/input';
import { RadioCheckList } from 'ui-components/components/radio-check-list';
import { RadioCheckListItem } from 'ui-components/components/radio-check-list/radio-check-list-item';

import { LabeledField } from '../../../configure-shipment/fields';
import { CreateReturnLabelAction, useCreateReturnContext } from '../../../context/create-return-provider';
import messages from './messages';

import style from './configure-return-shipment.module.less';

const downloadNowOptionFieldId = 'download-return-label-now-option';
const emailOptionFieldId = 'email-return-label-option';
const emailAddressFieldId = 'return-label-email-address';

const CreateReturnLabelActionOptions = () => {
  const { selectedCreateLabelOption, selectDownloadLabel, selectEmailLabel, updateEmailCSV, emailAddressCSV, hasEmailValidationError } =
    useCreateReturnContext();

  const isDownloadSelected = selectedCreateLabelOption === CreateReturnLabelAction.Download;
  const isEmailSelected = selectedCreateLabelOption === CreateReturnLabelAction.Email;

  return (
    <div className={style['label-options-container']}>
      <RadioCheckList className={style['label-options']}>
        <RadioCheckListItem
          className={style['label-option']}
          id={downloadNowOptionFieldId}
          isChecked={isDownloadSelected}
          onChecked={selectDownloadLabel}
        >
          <FormattedMessage {...messages.downloadOption} />
        </RadioCheckListItem>
        <RadioCheckListItem
          className={style['label-option']}
          id={emailOptionFieldId}
          isChecked={isEmailSelected}
          onChecked={selectEmailLabel}
        >
          <FormattedMessage {...messages.emailOption} />
        </RadioCheckListItem>
      </RadioCheckList>
      <LabeledField label={<FormattedMessage {...messages.emailAddressListLabel} />} labelFor={emailAddressFieldId}>
        <Input
          disabled={!isEmailSelected}
          id={emailAddressFieldId}
          inlineMessage={<FormattedMessage {...messages.emailAddressListInstructions} />}
          inlineMessageType={INLINE_MESSAGE_TYPES.sublabel}
          name={emailAddressFieldId}
          onChange={updateEmailCSV}
          type='text'
          value={emailAddressCSV}
          version={version2}
        />
        {hasEmailValidationError && (
          <InlineMessage type={INLINE_MESSAGE_TYPES.error}>
            <FormattedMessage {...messages.invalidEmail} />
          </InlineMessage>
        )}
      </LabeledField>
    </div>
  );
};

export default CreateReturnLabelActionOptions;
